import { ReactNode } from 'react';
import { InventoryAsset, PortalUserData, SupportCasesItem } from '../../../types';
import { useFetching } from '../../../Context/FetchingContext';
import { SupportCaseDetails } from '../../Pages/SupportCases';
import { InventoryDetails } from '../../Pages/Inventory/InventoryDetails';
import { UserDetails } from '../../Pages/Admin/Tabs/UserDetails';
import { Team } from '../../../store/Team';
import { TeamDetails } from '../../Pages/Admin/Tabs/TeamDetails';
import { AccountData } from '../../../store/Accounts';
import { AccountDetails } from '../../Pages/Admin/Tabs/Accounts/AccountDetails';
import { ComponentName } from './detailsDrawersHelpers';
import { ProjectAssetDetails } from '../../Pages/Projects/ProjectAssetDetails';
import { PriceBenchMark } from '../../../store/PriceBenchMark';
import { BenchmarkDetails } from '../../Pages/CostIntelligence/BenchmarkDetails';
import { WorkflowOrder } from '../../../Api/Orders/ordersApi';
import { WorkflowOrderDetails } from '../../Pages/Orders/WorkflowOrderDetails';
import { RelatedInventoryRiskItem } from '../../../Api/Projects/projectsApi';
import { LocationDetails } from '../../Pages/Inventory/LocationDetails';
import type { LocationGridRow } from '../../Pages/Inventory/locationsGridColumnDefs';

export interface DetailsDisplayProps {
  data:
    | InventoryAsset
    | SupportCasesItem
    | PortalUserData
    | Team
    | AccountData
    | PriceBenchMark
    | WorkflowOrder
    | LocationGridRow
    | null;
  componentName?: ComponentName;
  setShow: (show: boolean) => void;
  extraSection?: ReactNode;
}

export const DetailsDisplay = ({ data, componentName, setShow, extraSection }: DetailsDisplayProps) => {
  const { isFetching } = useFetching();
  if (isFetching || !data || !componentName) return <div></div>;

  const getComponentByName = () => {
    switch (componentName) {
      case 'support':
        return <SupportCaseDetails data={data as SupportCasesItem} />;
      case 'inventory':
        return (
          <InventoryDetails
            data={data as InventoryAsset}
            extraSection={extraSection}
          />
        );
      case 'workflow-order':
        return <WorkflowOrderDetails data={data as WorkflowOrder} />;
      case 'user':
        return (
          <UserDetails
            userData={data as PortalUserData}
            setShow={setShow}
          />
        );
      case 'team':
        return <TeamDetails data={data as Team} />;
      case 'account':
        return <AccountDetails data={data as AccountData} />;
      case 'project-asset':
        return <ProjectAssetDetails asset={data as RelatedInventoryRiskItem} />;
      case 'benchmark':
        return <BenchmarkDetails benchmark={data as PriceBenchMark} />;
      case 'location':
        return (
          <LocationDetails
            key={(data as LocationGridRow).location_key}
            location={data as LocationGridRow}
            close={() => setShow(false)}
          />
        );
      default:
        return null;
    }
  };

  return <div className="overflow-auto">{getComponentByName()}</div>;
};
